import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScimEndpoints = api(async function getScimEndpoints() {
    return await query(
        gql`
            query getScimEndpoints {
                getScimEndpoints {
                    baseUrl
                    usersUrl
                    groupsUrl
                }
            }
        `,
        {},
        { returns: "getScimEndpoints" }
    )
})
